import React, { useState, useEffect } from "react";
import { Box, TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody } from "@mui/material";
import { useSelector} from "react-redux"
import Task04DetailDialog from "./Task04DetailDialog"
import CustomPagination from "../../../component/common/CustomPagination";

export interface TfqaType {
  idx: number;
  id: string;
  worker: string;
  work_date: string;
  work_yn: string;
  use_check: string;

  prc_worker: string;
  prc_date: string;
  prc_yn: string;

  isp_worker: string;
  isp_date: string;
  isp_yn: string;

  category: string;
  answer: string;

  translate_need: string;

  question_vi : string;
  best_answer_vi : string;
  correct_answer_vi_1 : string;
  correct_answer_vi_2 : string;
  correct_answer_vi_3 : string;
  correct_answer_vi_4 : string;
  correct_answer_vi_5 : string;
  correct_answer_vi_6 : string;
  incorrect_answer_vi_1 : string;
  incorrect_answer_vi_2 : string;
  incorrect_answer_vi_3 : string;
  incorrect_answer_vi_4 : string;
  incorrect_answer_vi_5 : string;
  incorrect_answer_vi_6 : string;
  
  question_ko : string;
  best_answer_ko : string;
  correct_answer_ko_1 : string;
  correct_answer_ko_2 : string;
  correct_answer_ko_3 : string;
  correct_answer_ko_4 : string;
  correct_answer_ko_5 : string;
  correct_answer_ko_6 : string;
  incorrect_answer_ko_1 : string;
  incorrect_answer_ko_2 : string;
  incorrect_answer_ko_3 : string;
  incorrect_answer_ko_4 : string;
  incorrect_answer_ko_5 : string;
  incorrect_answer_ko_6 : string;
  
  question_en : string;
  best_answer_en : string;
  correct_answer_en_1 : string;
  correct_answer_en_2 : string;
  correct_answer_en_3 : string;
  correct_answer_en_4 : string;
  correct_answer_en_5 : string;
  correct_answer_en_6 : string;
  incorrect_answer_en_1 : string;
  incorrect_answer_en_2 : string;
  incorrect_answer_en_3 : string;
  incorrect_answer_en_4 : string;
  incorrect_answer_en_5 : string;
  incorrect_answer_en_6 : string;

}

const initailData: TfqaType = {
  idx: -1,
  id: "",
  worker: "",
  work_date: "",
  work_yn: "",
  use_check: "",

  prc_worker: "",
  prc_date: "",
  prc_yn: "",

  isp_worker: "",
  isp_date: "",
  isp_yn: "",

  category: "",
  answer: "",

  translate_need:"",

  question_vi : "",
  best_answer_vi : "",
  correct_answer_vi_1 : "",
  correct_answer_vi_2 : "",
  correct_answer_vi_3 : "",
  correct_answer_vi_4 : "",
  correct_answer_vi_5 : "",
  correct_answer_vi_6 : "",
  incorrect_answer_vi_1 : "",
  incorrect_answer_vi_2 : "",
  incorrect_answer_vi_3 : "",
  incorrect_answer_vi_4 : "",
  incorrect_answer_vi_5 : "",
  incorrect_answer_vi_6 : "",
  
  question_ko : "",
  best_answer_ko : "",
  correct_answer_ko_1 : "",
  correct_answer_ko_2 : "",
  correct_answer_ko_3 : "",
  correct_answer_ko_4 : "",
  correct_answer_ko_5 : "",
  correct_answer_ko_6 : "",
  incorrect_answer_ko_1 : "",
  incorrect_answer_ko_2 : "",
  incorrect_answer_ko_3 : "",
  incorrect_answer_ko_4 : "",
  incorrect_answer_ko_5 : "",
  incorrect_answer_ko_6 : "",
  
  question_en : "",
  best_answer_en : "",
  correct_answer_en_1 : "",
  correct_answer_en_2 : "",
  correct_answer_en_3 : "",
  correct_answer_en_4 : "",
  correct_answer_en_5 : "",
  correct_answer_en_6 : "",
  incorrect_answer_en_1 : "",
  incorrect_answer_en_2 : "",
  incorrect_answer_en_3 : "",
  incorrect_answer_en_4 : "",
  incorrect_answer_en_5 : "",
  incorrect_answer_en_6 : "",
};

interface pageInfoType {
  current_page: number;
  total_pages: number;
  total_count: number;
}

const Task04ListPage = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)
  
  const [data, setData] = useState<TfqaType>(initailData);

  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );
  
  const updateAfter = () => {
    setData(initailData);
    props.vieWorkList(props.work_yn,props.use_check,props.task);
  }

  useEffect(() => {
    if(props.workList.datas != undefined && props.workList.task == "vie_04_truthful_qa"){
      setData(props.workList.datas[0])
    }
    if(props.workList.pagination != undefined){
      setPagination(props.workList.pagination)
    }
  },[props])

  return (
    <Box>
      {/* Task 단위 화면 */}
      <Box display="flex" justifyContent="center" >
        <Box sx={{padding:"20px 8px 8px 8px", width:"400px"}}>
          <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Task-04. TFQA</Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
          <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
            <Table size="small" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                  {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>ID</Box></TableCell> */}
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>USE_CHECK</Box></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {(props.workList.datas != undefined && props.workList.datas.length > 0)  ? props.workList.datas.map((row:any, index:number) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(data != undefined && row.idx === data.idx ? "#dbdbef": "#fff")}}
                  onClick={()=> {setData(row);}}
                >
                  <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                  {/* <TableCell align="left">{row.concept_en}</TableCell> */}
                  <TableCell align="left">
                    <Box sx={{width:"58px",fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                        border: (row.use_check === "F" ? "2px solid red" : (row.use_check === "T" ? "2px solid #498ad5" : (row.use_check === "C" ? "2px solid #27cc2f" : "#bbb"))), color:"#000" }}>
                      {(row.use_check === "T" ? "사용가능" : (row.use_check === "F" ? "사용불가" : (row.use_check === "C" ? "내용수정":"미분류")))}
                    </Box>
                  </TableCell>
                </TableRow>
                )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{marginTop:"12px"}}>
            {pagination !== undefined ? (
                <CustomPagination pagination={pagination} goPage={props.goPage} />
            ) : ""}
          </Box>
        </Box>
        <Task04DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />
      </Box>
    </Box>


  );
};

export default Task04ListPage;
